import type { JSX } from 'react'

import { AuthLayoutTemplate } from "/app/libraries/arcana/src/blocks/AuthLayout/Templates/index.ts"
import { AuthLayoutWrapper } from "/app/libraries/arcana/src/blocks/AuthLayout/index.ts"
import { BrandContainerDefault } from "/app/libraries/arcana/src/blocks/BrandContainer/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useEffect, useMemo } from 'react'
import { model as logoModel } from '~/features/logo'
import { signInByTrueIdFeatureModel } from '~/features/subscriber/sign-in'
import { aye } from '~/shared/helpers'
import { Footer } from '~/shared/ui/components/Footer'
import { $authBackgroundUrl, $backgroundLoaded, loadBackground } from './model'

interface Props {
  children: React.ReactNode
  withImageBackground?: boolean
}

AuthLayout.displayName = 'AuthLayout'
export function AuthLayout({
  children,
  withImageBackground = true,
}: Props): JSX.Element | null {
  const backgroundLoaded = useUnit($backgroundLoaded)
  const logoUrl = useUnit(logoModel.$logoUrl)
  const backgroundUrl = useUnit($authBackgroundUrl)
  const logoHeight = useUnit(logoModel.$logoHeight)
  const trueIdConfig = useUnit(signInByTrueIdFeatureModel.$trueIdConfig)

  // form vertical alignment === center if trueId authorization enabled
  const isMobileVerticalAlignment = useMemo(
    () => aye(trueIdConfig),
    [trueIdConfig]
  )
  useEffect(() => {
    loadBackground()
  }, [])

  return (
    <AuthLayoutWrapper>
      <AuthLayoutTemplate
        posterUrl={withImageBackground ? backgroundUrl : ''}
        backgroundOpacity={backgroundLoaded ? 1 : 0}
        backgroundOpacityTransitionDuration={1}
        paddingTop='110px'
        isMobileVerticalAlignment={isMobileVerticalAlignment}
      >
        <a href='/'>
          <BrandContainerDefault
            scaleLogo={true}
            logoHeight={logoHeight || '60px'}
            logoUrl={logoUrl}
          />
        </a>
        {children}
      </AuthLayoutTemplate>
      <Footer />
    </AuthLayoutWrapper>
  )
}
